import dayjs from 'dayjs';
import { h, ref } from 'vue';
import { useMessage } from '../hooks/web/useMessage';

const { createExclamationModal } = useMessage();

const loadVersion = async () => {
  const url = new URL('/version.json?t=' + +dayjs(), import.meta.url).href;
  const response = await fetch(url);
  return response.json();
};

const key = 'wh-sys-version';
export const currentVersion = ref(localStorage.getItem(key));
export const hasUpdate = ref(false);
let exclamationModal = {
  destroy: () => {},
};
export const checkSysVersion = async (genUpdate = true) => {
  const res = await loadVersion();
  if (!currentVersion.value) {
    currentVersion.value = res.version;
    localStorage.setItem(key, res.version);
    return false;
  }
  if (currentVersion.value !== res.version) {
    localStorage.setItem(key, res.version);
    hasUpdate.value = true;
    if (genUpdate) {
      sysUpdate();
    } else {
      exclamationModal.destroy();
      exclamationModal = createExclamationModal({
        title: '更新提醒',
        content: h('div', [
          `检测到新版本：${res.version}，您可点击立即更新或稍后点击系统左下角手工更新。`,
          h('div', { class: 'price' }, '更新会刷新系统，请确保所有数据已经提交以免丢失。'),
        ]),
        okText: '立即更新',
        onOk: () => {
          sysUpdate();
        },
        cancelText: '稍后更新',
      });
    }
    return true;
  }
  return false;
};
export const sysUpdate = () => {
  (location as any).reload(true);
};
checkSysVersion();

// 定时检测更新
setInterval(() => {
  const now = dayjs();
  // 只在工作时间内检测更新
  if (now.hour() < 8 || now.hour() > 20) {
    return;
  }
  // 每10分钟检测一次更新
  if (now.minute() % 10 !== 0) {
    return;
  }
  checkSysVersion(false);
}, 60000);
